export default __webpack_public_path__ + "assets/img_realestate-43a4bcb5.png";